<template>
    <b-modal :id="`confirm-modal-${id}`"
             title="Confirmation"
             footer-class="d-flex justify-content-between"
             ok-title="Yes"
             ok-variant="success"
             cancel-title="No"
             cancel-variant="danger"
             @ok="$emit('confirm')">
        <h6 class="my-2">Are you sure?</h6>
    </b-modal>
</template>

<script>
    export default {
        name: 'ConfirmModal',
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {}
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Modals/ConfirmModal.vue